import { useState, useEffect, useRef, useCallback } from 'react'

const DEBOUNCE_DELAY = 500

export const useDebouncedFieldUpdate = <T,>(
  initialValue: T,
  onUpdate: (value: T) => void,
  deps: unknown[] = []
) => {
  const [value, setValue] = useState(initialValue)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleChange = useCallback(
    (newValue: T) => {
      setValue(newValue)
      if (debounceRef.current) clearTimeout(debounceRef.current)
      debounceRef.current = setTimeout(() => onUpdate(newValue), DEBOUNCE_DELAY)
    },
    [onUpdate, ...deps]
  )

  return [value, setValue, handleChange] as const
}
